export enum EBzAlertTypes {
  Completed = 1,
  Error = 2,
  Warning = 3,
  Info = 4
}
